import { utils } from "../../../ms_front_lib/utils";
import { is_on_mobile } from "../../app";

export class EMSHallMap{
    constructor(iParam) {
        gl_app.EMSHallMap = this;
        // console.log("EMSHallMap", iParam)
        this.data_hall_map = iParam.data_hall_map ? iParam.data_hall_map : null;
        this.data_seats = iParam.data_hall_map && iParam.data_hall_map.data_seats ? iParam.data_hall_map.data_seats : null;  
        this.data_session = iParam.data_session;
        this.data_superbillet = iParam.data_superbillet;
        this.data_movie = iParam.data_movie;
        this.is_session = iParam.is_session;
        this.is_superbillet = iParam.is_superbillet;
        this.from = iParam.from;
        this.session_id = this.data_session ? this.data_session.ems_id : 0;
        this.superbillet_id = this.is_superbillet ? this.data_superbillet.id : 0;
        this.$parent = iParam.$parent;
        
        this.data_basket = gl_app.EMSBasket.get_data();
        this.nb_seats_session = 0;
        this.nb_seats_already_choosen = 0;
        this.seats_already_selected = [];
        $.each(this.data_basket.billetterie,(key,value) => {
            switch(key){
                case "session":
                    // ===== On boucle sur chaque séance =====
                    $.each(value,(key,value) => {
                        if(key != this.session_id){
                            return;
                        }
                        value.seats.forEach(seat => {
                            this.seats_already_selected.push(seat)
                        });
                    });
                    break;
                case "superbillet":
                    $.each(value,(key,value) => {
                        if(key != this.superbillet_id){
                            return;
                        }
                        $.each(value.list_session,(key, value) => {
                            if(key != this.session_id){
                                return;
                            }
                            value.seats.forEach(seat => {
                                this.seats_already_selected.push(seat)
                            });
                        });
                    });
                    break;
                default:
                    break;
            }
        });
        $.each(this.data_basket.waiting_seats,(key,value) => {
            switch(key){
                case "session":
                    // ===== On boucle sur chaque séance =====
                    $.each(value,(key,value) => {
                        if(key != this.session_id){
                            return;
                        }
                        value.seats.forEach(seat => {
                            this.seats_already_selected.push(seat)
                        });
                    });
                    break;
                case "superbillet":
                    $.each(value,(key,value) => {
                        if(key != this.superbillet_id){
                            return;
                        }
                        $.each(value.list_session,(key, value) => {
                            if(key != this.session_id){
                                return;
                            }
                            value.seats.forEach(seat => {
                                this.seats_already_selected.push(seat)
                            });
                        });
                    });
                    break;
                default:
                    break;
            }
        });

        this.tab_type_seat = [
            {
                "type" : "free_seat",
                "label" : _l("Siège libre"),
                "hide" : false
            },
            {
                "type" : "selected_seat",
                "label" : _l("Mes sièges"),
                "hide" : false
            },
            {
                "type" : "booked_seat",
                "label" : _l("Siège vendu"),
                "hide" : false
            },
            {
                "type" : "PMR_seat",
                "label" : _l("PMR"),
                "hide" : false
            },
            {
                "type" : "APMR_seat",
                "label" : _l("Accompagnant PMR"),
                "hide" : true
            },
            {
                "type" : "unavailable_seat",
                "label" : _l("Uniquement au cinéma"),
                "hide" : true
            },
            {
                "type" : "duo_seat",
                "label" : _l("Siège duo"),
                "hide" : false
            },
            {
                "type" : "duo_left_seat",
                "label" : _l("DUO gauche"),
                "hide" : false
            },
            {
                "type" : "duo_right_seat",
                "label" : _l("DUO droite"),
                "hide" : false
            },
            {
                "type" : "disabled_seat",
                "label" : _l("Inactif"),
                "hide" : true
            }
        ];
    }

    async create_map() {
        // console.log(this)
        const self = this;
        var seats_available = this.data_hall_map.seat;
        var seats_covid = this.data_hall_map.seat_covid;
        var has_couch = false;

        var $flex_wrap=$("<div/>").addClass("d-flex flex-column h-100").appendTo(this.$parent);
            var $box=$("<div/>").addClass("my-auto").attr({"id":"box_map"}).appendTo($flex_wrap);
                // // =====  Légende du plan de salle =====
                // var $row_legend=$("<div/>").addClass("row pt-1 text-center").attr({"id":"row_legend_hall_map"}).appendTo($box);
                //     var $col=$("<div/>").addClass("col-12 d-flex justify-content-center").attr({"id":"col_legend_hall_map"}).appendTo($row_legend);
                // this.tab_type_seat.forEach(type_seat => {
                //     var $wrap=$("<div/>").addClass("mx-1 mx-md-2 mx-lg-3").attr({"id":"wrap_"+type_seat.type}).appendTo($col);
                //         var $img=$("<img/>").addClass("img_seat").attr({"src":"https://static.monnaie-services.com/www-img/hall_map/"+type_seat.type+".png","alt":type_seat.label}).appendTo($wrap);
                //         var $label=$("<div/>").addClass("label_legend_hall_map").text(type_seat.label).appendTo($wrap);
                //     if(type_seat.hide){
                //         $wrap.hide();
                //     }
                // });

                // ===== Logo écran =====
                var $row_ecran=$("<div/>").addClass("row py-2 d-flex justify-content-center").appendTo($box);
                    var $col_ecran=$("<div/>").addClass("col-11 col-md-8 col-lg-6 d-flex justify-content-center").appendTo($row_ecran);
                        var $img=$("<img/>").addClass("img_screen w-100").attr({"src":"https://static.monnaie-services.com/www-img/hall_map/screen_"+(gl_config.site.lang).toLowerCase()+".png","alt":_l("Ecran")}).appendTo($col_ecran);  

                var $wrap_map_seats=$("<div/>").addClass("my-1 my-md-3").attr({"id":"wrap_map_seats"}).appendTo($box);
                    var $row_details=$("<div/>").addClass("row row_det_hall_map").appendTo($wrap_map_seats);
                    if(this.is_session){
                        $row_details.attr({"id":"row_det_hall_map_session_"+this.session_id});
                    }else if(this.is_superbillet){
                        $row_details.attr({"id":"row_det_hall_map_superbillet_"+this.superbillet_id});
                    }
                        var $col_details_hall_map=$("<div/>").addClass("col-12").attr({"id":"col_det_hall_map"}).appendTo($row_details);
                            var $container_seats=$("<div/>").addClass("position-relative m-auto h-100").attr({"id":"container_seats"}).appendTo($col_details_hall_map);

                // On fait un premier parcours afin de savoir si le plan de salle dispose de banquette/lit
                for(var i=0;i<this.data_seats.length;i++){
                    if ((this.data_seats[i].is_couch || this.data_seats[i].type == 7) ){
                        has_couch = true;
                    }
                }

                var posX; var posY;
                var posX_max = 0; var posY_max = 0;
                let tab_section=[];
                let section_temp=null;
                let nb_section = 0;
                for(var i=0;i<this.data_seats.length;i++){
                    var decalageH=0; var decalageV=0; 
                    var place_vendue=false;
                    var siege_covid=false;
                    var text_info_siege="";
                    var informations_siege=this.data_seats[i].informations;
                    
                    // ===== On calcul l'emplacement du siège =====
                    if(this.data_seats[i].column_offset){decalageH=10;}
                    if(this.data_seats[i].line_offset){decalageV=10;}
                    posX=((this.data_seats[i].column-1)*36) + decalageH;   // seat width : 30px
                    if(has_couch){
                        posY=((this.data_seats[i].line-1)*33) + decalageV + 10;     // seat height : 24px
                    }else{
                        posY=((this.data_seats[i].line-1)*28) + decalageV;     // seat height : 24px
                    }
                    

                    if (posX > posX_max) {
                        posX_max = posX;
                    }
                    if (posY > posY_max) {
                        posY_max = posY;
                    }

                    // ==== Si siège DUO droite =====
                    if((this.data_seats[i].sofa == "right" || this.data_seats[i].type == 6) ){
                        posX = posX - 3 ; 
                        // vu que l'on agrandit la largeur des sièges de X px, on retire X px sur la position du siège de droite
                        // afin q'uil soit collé au siège de gauche
                    }

                    // ==== Si siège banquette/lit =====
                    if ((this.data_seats[i].is_couch || this.data_seats[i].type == 7) ){
                        posY = posY - 5 ; 
                    }
                    
                    // ===== Les places sans nom sont des emplacements vides =====
                    if(this.data_seats[i].name!=""){
                        // ===== Nom du siège affiché à l'écran (différent selon le pays) =====
                        var name_seat_on_screen=gl_app.ParseurNameSeats(this.data_seats[i].name);
                        
                        // ===== Section du plan de salle =====
                        var tab_section_temp=this.data_seats[i].section.split("|");
                        var section=tab_section_temp[0];
                        
                        if(section_temp!==section){
                            nb_section++;
                            tab_section.push(section)
                        };
                        section_temp=section;
                        
                        // ===== Création du siège =====
                        var $wrap_seat=$("<div/>").addClass("position-absolute").appendTo($container_seats).appendTo($container_seats).css({
                            "left":posX,
                            "top":posY
                        });
                            var $siege=$("<img/>").data({seat_name:this.data_seats[i].name, seat_section:section, "type" : this.data_seats[i].type}).addClass("img_seat position-absolute "+this.data_seats[i].name+" section_"+section).appendTo($wrap_seat)
                            .on('click',(e) => {
                                let $t = $(e.currentTarget);
                                let seat_info = {};
                                seat_info.element = $t;
                                seat_info.type = $t.data("type");
                                seat_info.seat_name = $t.data("seat_name");
                                seat_info.seat_section = $t.data("seat_section");
                                seat_info.is_session = this.is_session;
                                seat_info.is_superbillet = this.is_superbillet;
                                seat_info.data_session = this.data_session;
                                seat_info.data_superbillet = this.data_superbillet;

                                if($t.hasClass("selected")){
                                    // self.unselect_seat({
                                    //     "seat_info":seat_info
                                    // });
                                    gl_app.EMSBasket.unselect_seat({
                                        "seat_info":seat_info
                                    });
                                }else{
                                    // self.select_seat({
                                    //     "seat_info":seat_info
                                    // });
                                    gl_app.EMSBasket.select_seat({
                                        "seat_info":seat_info
                                    });
                                };
                            });
                            
                            // ===== On check la liste des places disponibles =====
                            if(seats_available.indexOf(this.data_seats[i].name)<0){
                                place_vendue=true;
                            }

                            // ===== On check la liste des places COVID =====
                            if(seats_covid.indexOf(this.data_seats[i].name)>=0){
                                place_vendue=false;
                                siege_covid=true;
                            }
                                                
                            if(this.data_seats[i].web==0){
                                // ===== Sièges non réservable en ligne =====
                                text_info_siege=_l("Uniquement au cinéma");
                                $siege.off('click');
                                if ((this.data_seats[i].sofa == "left" || this.data_seats[i].type == 5) ){
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/unavailable_duo_left_seat.png"});
                                }else if ((this.data_seats[i].sofa == "right" || this.data_seats[i].type == 6) ){
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/unavailable_duo_right_seat.png"});
                                }else if ((this.data_seats[i].is_couch || this.data_seats[i].type == 7) ){
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/unavailable_couch.png"});
                                    $siege.addClass("couch");
                                }else{
                                    $siege.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/unavailable_seat.png"});
                                }
                                $("#wrap_unavailable_seat").show();
                            }else if(place_vendue){
                                // ===== Sièges vendus =====
                                text_info_siege=_l("Siège vendu");
                                $siege.off('click');
                                if ((this.data_seats[i].sofa == "left" || this.data_seats[i].type == 5) ){
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/booked_duo_left_seat.png"});
                                }else if ((this.data_seats[i].sofa == "right" || this.data_seats[i].type == 6) ){
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/booked_duo_right_seat.png"});
                                }else if ((this.data_seats[i].is_couch || this.data_seats[i].type == 7) ){
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/booked_couch.png"});
                                    $siege.addClass("couch");
                                }else{
                                    $siege.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/booked_seat.png"});
                                }
                            }else if(informations_siege && informations_siege.Invendable){
                                // ===== Sièges invendable  =====
                                text_info_siege=_l("Inactif");
                                $siege.off('click');
                                if ((this.data_seats[i].sofa == "left" || this.data_seats[i].type == 5) ){
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/disabled_duo_left_seat.png"});
                                }else if ((this.data_seats[i].sofa == "right" || this.data_seats[i].type == 6) ){
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/disabled_duo_right_seat.png"});
                                }else if ((this.data_seats[i].is_couch || this.data_seats[i].type == 7) ){
                                    $siege.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/disabled_couch.png"});
                                    $siege.addClass("couch");
                                }else{
                                    $siege.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/disabled_seat.png"});
                                }
                                $("#wrap_disabled_seat").show();
                            }else if(siege_covid){
                                // ===== Siège COVID =====
                                text_info_siege=_l("COVID-19 : Siège non réservable pour respecter les mesures de distanciation sociale");
                                $siege.off('click');
                                if ((this.data_seats[i].sofa == "left" || this.data_seats[i].type == 5) ){
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/disabled_duo_left_seat.png"});
                                }else if ((this.data_seats[i].sofa == "right" || this.data_seats[i].type == 6) ){
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/disabled_duo_right_seat.png"});
                                }else if ((this.data_seats[i].is_couch || this.data_seats[i].type == 7) ){
                                    $siege.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/disabled_couch.png"});
                                    $siege.addClass("couch");
                                }else{
                                    $siege.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/disabled_seat.png"});
                                }
                                $("#wrap_disabled_seat").show();
                            }else{
                                $siege.addClass("pointer");
                                $siege.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/free_seat.png"});
                                text_info_siege=_l("Siège standard");
                                $siege.data({"type":"standard"});

                                // ===== Strapontin =====
                                // ===== DUO pour le moment =====
                                if ((this.data_seats[i].is_folding_seat || this.data_seats[i].type == 3)) {
                                    $siege.removeAttr("src");
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/duo_seat.png"});
                                    text_info_siege=_l("Siège duo");
                                    text_info_siege += ". "+_l("Un fauteuil sur deux");
                                    $siege.data({"type": "DUO"});
                                    $("#wrap_duo_seat").show();
                                }else if ((this.data_seats[i].for_disabled || this.data_seats[i].type == 2)) {
                                    // ===== Handicapé =====
                                    $siege.removeAttr("src");
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/PMR_seat.png"});
                                    text_info_siege = _l("PMR");
                                    $siege.data({"type":"PMR"});
                                    $("#wrap_PMR_seat").show();
                                }else if ((this.data_seats[i].next_disabled || this.data_seats[i].type == 4)) {
                                    // ===== Accompagnant PMR =====
                                    $siege.removeAttr("src");
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/APMR_seat.png"});
                                    text_info_siege = _l("Accompagnant PMR");
                                    $("#wrap_APMR_seat").show();
                                }else if ((this.data_seats[i].sofa == "left" || this.data_seats[i].type == 5) ){
                                    // ===== DUO gauche =====
                                    $siege.removeAttr("src");
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/duo_left_seat.png"});
                                    text_info_siege = _l("DUO gauche");
                                    $siege.data({"type": "duo_left"});
                                    $("#wrap_duo_left_seat").show();
                                }else if ((this.data_seats[i].sofa == "right" || this.data_seats[i].type == 6) ){
                                    // ===== DUO droite =====
                                    $siege.removeAttr("src");
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/duo_right_seat.png"});
                                    text_info_siege = _l("DUO droite");
                                    $siege.data({"type": "duo_right"});
                                    $("#wrap_duo_right_seat").show();
                                }else if((this.data_seats[i].is_couch || this.data_seats[i].type == 7)){
                                    $siege.removeAttr("src");
                                    $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/couch.png"});
                                    text_info_siege = _l("Transat");
                                    $siege.data({"type": "couch"});
                                    $siege.addClass("couch");
                                };
                            };

                            if((this.data_seats[i].sofa == "left" || this.data_seats[i].type == 5)  || (this.data_seats[i].sofa == "right" || this.data_seats[i].type == 6) ){
                                $siege.css({
                                    "width" : $siege[0].width + 3
                                })
                            }
                        
                        // ===== On check la liste des places déjà sélectionnées =====
                        if(this.seats_already_selected.length>0 && this.seats_already_selected.indexOf(this.data_seats[i].name)>=0){
                            $siege.addClass("selected");
                            if ((this.data_seats[i].sofa == "left" || this.data_seats[i].type == 5) ){
                                $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/selected_duo_left_seat.png"});
                            }else if ((this.data_seats[i].sofa == "right" || this.data_seats[i].type == 6) ){
                                $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/selected_duo_right_seat.png"});
                            }else if ((this.data_seats[i].is_couch || this.data_seats[i].type == 7) ){
                                $siege.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/selected_couch.png"});
                                $siege.addClass("couch");
                            }else{
                                $siege.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/selected_seat.png"});
                            }
                        }

                        // Sera insérer dans le "title" du tooltip =====
                        var $tooltip_content=$("<div/>").addClass("d-none tooltip_content").appendTo($siege);
                            var $wrap=$("<div/>").addClass("d-flex").appendTo($tooltip_content);
                                var $div=$("<div/>").addClass("flex-40 d-flex box-radius-left").appendTo($wrap);
                                    var $text=$("<div/>").addClass("py-1 px-2 m-auto bold seat_label").text(name_seat_on_screen).appendTo($div);
                                var $div=$("<div/>").addClass("flex-60 d-flex bg-secondary-tc box-radius-right").appendTo($wrap);
                                    var $text=$("<div/>").addClass("py-1 px-2 m-auto bold text_info").text(text_info_siege).appendTo($div);
                                            
                        $siege.tooltip({
                            html:true,
                            title:$tooltip_content.html()
                        });
                    };
                };

                // ===== On met la hauteur et largeur de la zone du plan de salle en fonction du nb de siege =====
                $col_details_hall_map.css({height:(posY_max+34)});
                if(is_on_mobile()){
                    $container_seats.css({width:(posX+48)});
                }else{
                    $container_seats.css({width:(posX_max+44)});
                };

                // ===== Si la plan de salle est plus large sur la largeur de l'écran, on ajoute un scroll horizontal =====
                if($container_seats.width()>$("#block_hall_map").width()){
                    $(".row_det_hall_map").css({
                        "overflow-x" : "scroll"
                    });

                    var elem = null;
                    if(this.is_session){
                        elem = document.getElementById("row_det_hall_map_session_"+this.session_id);
                    }else if(this.is_superbillet){
                        elem = document.getElementById("row_det_hall_map_superbillet_"+this.superbillet_id);
                    }

                    let isMouseDown = false;
                    let startX;
                    let scrollLeft;
                    let scale = 1;

                    elem.addEventListener("mousedown", (event) => {
                        event.preventDefault();
                        isMouseDown = true;
                        startX = event.pageX;
                        scrollLeft = elem.scrollLeft;
                        self.is_dragging = false;
                    });
                    elem.addEventListener("mousemove", (event) => {
                        if (!isMouseDown) {
                            return;
                        }
                        event.preventDefault();
                        const x = event.pageX - elem.offsetLeft;
                        const walk = (x - startX) * 1;
                        elem.scrollLeft = scrollLeft - walk;
                        if(walk < -25 || walk > 25){
                            self.is_dragging = true;
                        }
                    });
                    elem.addEventListener('mouseleave', () => {
                        isMouseDown = false;
                    });
                    elem.addEventListener("mouseup", () => {
                        isMouseDown = false;
                    });
                };

                // ===== Texte arrière de la salle =====
                var $row_back_hall=$("<div/>").addClass("row py-2 d-flex justify-content-center").attr({"id":"row_back_hall"}).appendTo($box);
                    var $col_back_hall=$("<div/>").addClass("col-11 col-md-8 col-lg-6 d-flex justify-content-center").attr({"id":"col_back_hall"}).appendTo($row_back_hall);
                        var $img=$("<img/>").addClass("img_screen w-100").attr({"src":"https://static.monnaie-services.com/www-img/hall_map/back_hall_"+(gl_config.site.lang).toLowerCase()+".png","alt":_l("Arrière de la salle")}).appendTo($col_back_hall);
    }
}